export default [
  {
    path: '/store/step1',
    name: 'step1',
    meta: {
      title: '签订入驻协议'
    },
    component: () => import('@/views/seller/step1.vue')
  }, {
    path: '/store/step2',
    name: 'step2',
    meta: {
      title: '公司资质信息'
    },
    component: () => import('@/views/seller/step2.vue')
  }, {
    path: '/store/step3',
    name: 'step3',
    meta: {
      title: '财务资质信息'
    },
    component: () => import('@/views/seller/step3.vue')
  }, {
    path: '/store/step4',
    name: 'step4',
    meta: {
      title: '店铺经营信息'
    },
    component: () => import('@/views/seller/step4.vue')
  }, {
    path: '/store/step5',
    name: 'step5',
    meta: {
      title: '店铺开通'
    },
    component: () => import('@/views/seller/step5.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/step.js